<template>
    <!--
      	作者：lpf
      	时间：2020-10-10
      	描述：diy组件-模拟显示-菜单组
      -->
    <div @click.stop="$parent.$parent.onEditer(index)">
      <div class="drag optional " :class="{selected:index === selectedIndex}">
        <div class="diy-menu2 box_g" :key="index" v-for="(menu,index) in item.data">
            <div class="box_left">
              <img class="box_img1" v-img-url="menu.imgUrl"/>
              <div :style="{color:menu.color}" style="margin-left: 10px;">{{menu.text}}</div>
            </div>
          <div class="box_img2">
            <i class="icon iconfont2 icon-right"></i>
          </div>
        </div>
        <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
      </div>
    </div>

</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style lang="scss" scoped>
@import '../../../../../components/page/static/iconfont2.css';

.box_g {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px;
  border-bottom: 1px solid #ccc;
}

.box_left {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.box_left .box_img1 {
  width: 30px;
  height: 30px;
  border-radius: 20px;
}

.box_txt {
  font-size: 78px;
}

.box_g .box_img2 {
  width: 20px;
  height: 20px;
  /*text-align: right;*/
}

.diy-menu2 .list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.diy-menu2 .list .item {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.diy-menu2 .list.column-3 .item {
  width: 33.333333333%;
}

.diy-menu2 .list.column-4 .item {
  width: 25%;
}

.diy-menu2 .list.column-5 .item {
  width: 20%;
}

.diy-menu2 .list .item-image {
  width: 60%;
}

.diy-menu2 .list .item-image img {
  width: 100%;
}

.diy-menu2 .list .item-text {
  width: 100%;
  padding: 4px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Menu.vue